import React from "react";
import "../styles/circularProgress.scss";

const CircularProgress = ({ className = "", label }) => {
  const classes = ["circular-progress", className].filter(Boolean).join(" ");

  return (
    <div className={classes} role={label ? "status" : undefined}>
      <div className="loader" aria-hidden="true"></div>
      {label && <span className="circular-progress__label">{label}</span>}
    </div>
  );
};

export default CircularProgress;
